import { Stack } from 'common/ui/Layout';
import Text from 'common/ui/Text';
import { Colors } from 'styles';
import { Renderer } from '../../RichTextEditor/renderer/Renderer';
import type { SlateContent } from '../types';
import { RightDrawerEmptyPreviewState } from './RightDrawerEmptyPreviewState';
import { RightDrawerPreviewBox } from './RightDrawerPreviewBox';

type MacroPreviewBodyProps = {
  macroContent: Nullable<SlateContent>;
  showPreviewLabel?: boolean;
  maxHeight?: number;
  testID?: string;
};

export const MacroPreviewBody = ({
  macroContent,
  showPreviewLabel = false,
  maxHeight,
  testID,
}: MacroPreviewBodyProps): React.ReactElement => {
  return (
    <Stack vertical stretchY data-stack-stretch css={{ height: '100%', minHeight: 0 }} space="none">
      {showPreviewLabel ? (
        <Text variant="body2" color={Colors.gray8}>
          Preview
        </Text>
      ) : null}
      <RightDrawerPreviewBox
        vertical
        data-testid={testID}
        data-scrollable={maxHeight != null}
        data-max-height={maxHeight}
        css={{
          marginTop: showPreviewLabel ? 4 : 0,
          flex: 1,
          minHeight: 0,
          ...(maxHeight != null
            ? {
                maxHeight,
              }
            : {}),
        }}
      >
        {macroContent != null ? (
          <Stack vertical space="medium" css={{ width: '100%', padding: '4px 12px' }}>
            <Renderer content={macroContent} />
          </Stack>
        ) : (
          <RightDrawerEmptyPreviewState>No macro content available.</RightDrawerEmptyPreviewState>
        )}
      </RightDrawerPreviewBox>
    </Stack>
  );
};
